/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Email
 *
 * 1 = WhatsApp
 *
 * 2 = Sms
 *
 * 3 = Facebook
 */
export enum AiContactTypes {
  Email = 0,
  WhatsApp = 1,
  Sms = 2,
  Facebook = 3,
}
